(function () {
  const CHARS = '!@#$%^&*<>?/~|ΔΩΨλ{}[]=+ABCdef0123456789';
  const DURATION = 1200;
  const INTERVAL = 45;

  function scramble(el) {
    const final = el.dataset.finalPrice || el.textContent.trim();
    el.dataset.finalPrice = final;
    const start = Date.now();

    const timer = setInterval(() => {
      const progress = (Date.now() - start) / DURATION;
      if (progress >= 1) {
        el.textContent = final;
        clearInterval(timer);
        return;
      }
      el.textContent = final.split('').map((char, i) => {
        if (!/\d/.test(char)) return char;
        const charProgress = progress - (i / final.length) * 0.4;
        if (charProgress >= 1) return char;
        if (charProgress <= 0) return CHARS[Math.floor(Math.random() * CHARS.length)];
        return Math.random() > charProgress ? CHARS[Math.floor(Math.random() * CHARS.length)] : char;
      }).join('');
    }, INTERVAL);
  }

  function init() {
    const waitForBucks = setInterval(() => {
      const elements = document.querySelectorAll('span.money');
      if (!elements.length) return;
      if (!elements[0].textContent.trim()) return;
      clearInterval(waitForBucks);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            scramble(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      elements.forEach((el) => observer.observe(el));
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();